import store from '@/store'
import router from '@/router/index'

class AppInstance {
    constructor() {
        this.mtoken = null
        this.init()
    }

    getQueryString(name) {
        let reg = new RegExp("(/?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.hash.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    }

    init() {
        let get_mtoken = this.getQueryString('mtoken')
        if (get_mtoken) localStorage.setItem('mtoken', get_mtoken);
        const mtoken = localStorage.getItem('mtoken')
        if (mtoken && mtoken != '' && mtoken != 'null') {
            this.mtoken = mtoken
        }
    }


    clearLoginInfo() {
        localStorage.removeItem('mtoken')
        router.push('/login')
    }

    setLoginInfo(data) {
        localStorage.setItem('mtoken', data);
        sessionStorage.removeItem('session_exists')
        this.mtoken = data;
        return true
    }

    updateTitle(title = '') {
        document.querySelector('title').text = title
    }
}

export function createAppInstance() {
    return new AppInstance()
}
